
    import React, { useState, useEffect } from 'react';
import { Card, Button, Spinner, Toast, Alert, Row, Col, Badge } from 'react-bootstrap';
import { CheckCircleFill, CreditCard2Front, Calendar3, Receipt, ArrowRight, BoxArrowUpRight, Whatsapp } from 'react-bootstrap-icons';
// Generated by Copilot — Migrated from Userfront to Clerk
import useAuthHeaders from '../hooks/useAuthHeaders';

const Suscripcion_Exitosa = () => {
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [sessionId, setSessionId] = useState('');
  const [showConfetti, setShowConfetti] = useState(true);
  const { userId, getToken } = useAuthHeaders();

  useEffect(() => {
    // Extract session_id from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const sessionIdFromUrl = urlParams.get('session_id');
    if (sessionIdFromUrl) {
      setSessionId(sessionIdFromUrl);
    }

    // Hide confetti after animation
    const timer = setTimeout(() => setShowConfetti(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleManageBilling = async () => {
    if (!userId) {
      setToastMessage('Debes iniciar sesión para continuar');
      setToastVariant('danger');
      setShowToast(true);
      return;
    }

    if (!sessionId) {
      setToastMessage('No se encontró información de la sesión');
      setToastVariant('danger');
      setShowToast(true);
      return;
    }

    setLoading(true);
    try {
      const token = await getToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Stripe/create-portal-session`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            sessionId: sessionId,
            userId: userId
          })
        }
      );

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'Error al crear la sesión del portal');
      }

      const data = await response.json();
      
      if (data.url) {
        window.location.href = data.url;
      } else {
        setToastMessage('Sesión del portal creada exitosamente');
        setToastVariant('success');
        setShowToast(true);
      }

    } catch (error) {
      console.error('Error:', error);
      setToastMessage(error.message);
      setToastVariant('danger');
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  const handleGoToDashboard = () => {
    window.location.href = '/dashboard';
  };

  return (
    <section className="py-4">
      {/* Confetti Animation CSS */}
      <style>
        {`
          @keyframes checkmark {
            0% { transform: scale(0); opacity: 0; }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); opacity: 1; }
          }
          
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          
          .success-icon {
            animation: checkmark 0.6s ease-out forwards;
          }
          
          .fade-in-up {
            animation: fadeInUp 0.5s ease-out forwards;
          }
          
          .fade-in-up-delay-1 { animation-delay: 0.1s; opacity: 0; }
          .fade-in-up-delay-2 { animation-delay: 0.2s; opacity: 0; }
          .fade-in-up-delay-3 { animation-delay: 0.3s; opacity: 0; }
          .fade-in-up-delay-4 { animation-delay: 0.4s; opacity: 0; }
          
          .success-card {
            border: none;
            border-radius: 16px;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
            overflow: hidden;
          }
          
          .success-header {
            background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
            padding: 3rem 2rem;
            text-align: center;
            color: white;
          }
          
          .plan-card {
            background: #f8f9fa;
            border-radius: 12px;
            padding: 1.5rem;
            border: 2px solid #e9ecef;
            transition: all 0.3s ease;
          }
          
          .plan-card:hover {
            border-color: #28a745;
            box-shadow: 0 4px 12px rgba(40, 167, 69, 0.15);
          }
          
          .feature-item {
            display: flex;
            align-items: center;
            padding: 0.5rem 0;
          }
          
          .feature-icon {
            width: 24px;
            height: 24px;
            background: #d4edda;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            flex-shrink: 0;
          }
          
          .action-button {
            border-radius: 10px;
            padding: 12px 24px;
            font-weight: 600;
            transition: all 0.3s ease;
          }
          
          .action-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
          
          .next-steps-card {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 12px;
            padding: 1.5rem;
            color: white;
          }
        `}
      </style>

      <Card className="success-card mx-auto" style={{ maxWidth: '600px' }}>
        {/* Success Header */}
        <div className="success-header">
          <div className="success-icon mb-3">
            <CheckCircleFill size={80} />
          </div>
          <h2 className="mb-2 fade-in-up fade-in-up-delay-1">¡Pago Exitoso!</h2>
          <p className="mb-0 opacity-75 fade-in-up fade-in-up-delay-2">
            Tu suscripción ha sido activada correctamente
          </p>
        </div>

        <Card.Body className="p-4">
          

          {/* Info Cards */}
          <Row className="g-3 mb-4 fade-in-up fade-in-up-delay-3">
            <Col xs={6}>
              <div className="text-center p-3 bg-light rounded-3">
                <Calendar3 size={24} className="text-primary mb-2" />
                <small className="d-block text-muted">Próximo cobro</small>
                <strong>
                  {new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString('es-MX', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric'
                  })}
                </strong>
              </div>
            </Col>
            <Col xs={6}>
              <div className="text-center p-3 bg-light rounded-3">
                <Receipt size={24} className="text-primary mb-2" />
                <small className="d-block text-muted">Método de pago</small>
                <strong>Tarjeta ****</strong>
              </div>
            </Col>
          </Row>

          {/* Next Steps */}
          <div className="next-steps-card mb-4 fade-in-up fade-in-up-delay-3">
            <h6 className="mb-3">
              <span className="me-2">🚀</span>
              ¿Qué sigue?
            </h6>
            <p className="mb-0 small opacity-90">
              Ya puedes comenzar a usar todas las funcionalidades de tu plan. 
              Ve al dashboard para empezar a utilizar nuestro servicio.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="d-grid gap-3 fade-in-up fade-in-up-delay-4">
            <Button
              variant="success"
              size="lg"
              className="action-button"
              onClick={handleGoToDashboard}
            >
              Ir al Dashboard
              <ArrowRight className="ms-2" />
            </Button>
            
            <Button
              variant="outline-secondary"
              className="action-button"
              onClick={handleManageBilling}
              disabled={loading || !sessionId}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Procesando...
                </>
              ) : (
                <>
                  <CreditCard2Front className="me-2" />
                  Administrar facturación
                  <BoxArrowUpRight className="ms-2" size={14} />
                </>
              )}
            </Button>
          </div>

          {/* Session Info (subtle) */}
          {sessionId && (
            <div className="text-center mt-4">
              <small className="text-muted">
                Referencia: {sessionId.substring(0, 20)}...
              </small>
            </div>
          )}

          {!sessionId && (
            <Alert variant="warning" className="mt-3 mb-0">
              <small>
                No se pudo obtener la información de la sesión. 
                Por favor, contacta a soporte si tienes problemas.
              </small>
            </Alert>
          )}

          {/* WhatsApp Contact */}
          <div className="text-center mt-4 pt-3 border-top">
            <small className="text-muted d-block mb-2">¿Tienes dudas?</small>
            <a 
              href="https://wa.me/529981957130?text=Hola,%20tengo%20una%20duda%20sobre%20mi%20suscripción" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              <Button variant="outline-success" size="sm" className="d-inline-flex align-items-center">
                <Whatsapp className="me-2" />
                Contáctanos por WhatsApp
              </Button>
            </a>
          </div>
        </Card.Body>
      </Card>

      {/* Toast Notification */}
      <Toast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        autohide
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          minWidth: '300px',
          zIndex: 9999
        }}
        bg={toastVariant}
      >
        <Toast.Header>
          <strong className="me-auto">
            {toastVariant === 'success' ? '✓ Éxito' : '⚠ Error'}
          </strong>
        </Toast.Header>
        <Toast.Body className={toastVariant === 'success' ? 'text-white' : ''}>
          {toastMessage}
        </Toast.Body>
      </Toast>
    </section>
  );
};

export default Suscripcion_Exitosa;